import React, { Component } from "react";
import { connect } from "react-redux";
import SidebarList from "features/Admin/components/SidebarList";
import ElementFocus from "features/Admin/components/ElementFocus";
import {
	adminGetAllAnalysisLibrary,
	adminGetAnalysisLibrary,
	adminPatchAnalysisLibrary,
	adminPostAnalysisLibrary,
	adminDeleteAnalysisLibrary,
	resetFocusAnalysisLibrary,
	initNewAnalysisLibrary,
} from "services/analysisLibrary";
import { adminGetAllTubeLibrary } from "services/tubeLibrary";
import { adminGetAllQuestionLibrary } from "services/questionLibrary";
import AdminDataContainer from "features/Admin/components/AdminDataContainer";
import { Grid, Icon, Loader, Dimmer } from "semantic-ui-react";
import RedButton from "components/Buttons/RedButton";
import GeneralForm from "features/Admin/Analyses/Forms/GeneralForm";
import CodesForm from "features/Admin/Analyses/Forms/CodesForm";
import { Form, Formik } from "formik";
import MainButton from "components/Buttons/MainButton";
import SecondaryButton from "components/Buttons/SecondaryButton";
import TubesForm from "features/Admin/Analyses/Forms/TubesForm";
import TakingForm from "features/Admin/Analyses/Forms/TakingForm";
import PretreatmentForm from "features/Admin/Analyses/Forms/PretreatmentForm";
import AnalyticsForm from "features/Admin/Analyses/Forms/AnalyticsForm";
import PatientForm from "features/Admin/Analyses/Forms/PatientForm";
import { getAnalysisImport, getAnalysisImportFile, getCatalogLogs } from "services/analysisService";
import moment from "moment";
import QuestionsFormOrder from "./Forms/QuestionsFormOrder";
import OthersForm from "./Forms/OthersForm";
import MotivationsForm from "./Forms/MotivationsForm";
import ImportModalLogs from "./ImportModalLogs";
import { isJson } from "utils/json";

class AnalysesAdmin extends Component {
	constructor(props) {
		super(props);
		this.state = {
			tubesSelected: [],
			questionsFactory: {
				list: this.props.questions.list.data,
				listLabel: "Liste des questions",
				selectedLabel: "Questions sélectionnées",
				value: null,
			},
			logs: null,
			logsOpen: false,
		};
	}

	componentDidMount() {
		this.getAllElements();
		if (this.props.analyses.focus.data !== null) {
			this.setupFactories(this.props.analyses.focus.data);
		}
	}

	setupFactories = (elt) => {
		const selectedQuestionObject =
			elt &&
			elt.questions &&
			elt.questions.filter((q) => q.question).map((q) => this.props.questions.list.data.find((l) => q.question && l.id === q.question?.id));
		this.setState({
			tubesSelected:
				elt !== undefined && elt !== null && elt.tubes !== undefined
					? elt.tubes.map((i) => {
							return { ...i, persisted: true };
					  })
					: [],
			questionsFactory: {
				list: this.props.questions.list.data
					.map((i) => {
						return {
							...i,
							name: i.code,

							persisted: false,
						};
					})
					.sort((a, b) => a.code.localeCompare(b.code)),
				listLabel: this.state.questionsFactory.listLabel,
				selectedLabel: this.state.questionsFactory.selectedLabel,
				value: selectedQuestionObject
					? selectedQuestionObject.map((i) => {
							return JSON.stringify({
								...i,
								name: i.code,
								persisted: false,
							});
					  })
					: [],
			},
		});
	};

	updateFactoryValue = (newSelected, name) => {
		this.setState((prevState) => ({
			...prevState,
			[name]: {
				...prevState[name],
				value: newSelected,
			},
		}));
	};

	resetFactories = () => {
		this.setState({
			tubesSelected: this.state.tubesSelected,
			questionsFactory: {
				list: this.state.questionsFactory.list,
				listLabel: this.state.questionsFactory.listLabel,
				selectedLabel: this.state.questionsFactory.selectedLabel,
				value: this.state.questionsFactory.value,
			},
		});
	};

	componentWillUnmount() {
		this.props.resetFocusAnalysisLibrary();
	}

	componentDidUpdate(prevProps) {
		if (this.props.analyses.focus.data !== prevProps.analyses.focus.data) {
			this.setupFactories(this.props.analyses.focus.data);
		}
	}

	getAllElements = () => {
		this.props.adminGetAllAnalysisLibrary();
		this.props.adminGetAllTubeLibrary();
		this.props.adminGetAllQuestionLibrary();
	};

	focusOnElement = (elt) => {
		this.props.adminGetAnalysisLibrary(elt);
	};

	saveFocus = (values, setSubmitting) => {
		delete values.questions;
		values.newQuestions = this.state.questionsFactory.value.filter((e) => isJson(e)).map((e) => JSON.parse(e).id);
		if (values.id === undefined) {
			delete values.id;
			this.props.adminPostAnalysisLibrary(values).then(() => {
				this.resetFactories();
				setSubmitting(false);
			});
		} else {
			this.props.adminPatchAnalysisLibrary(values).then(() => {
				this.resetFactories();
				setSubmitting(false);
			});
		}
	};

	deleteFocus = () => {
		this.props.adminDeleteAnalysisLibrary(this.props.analyses.focus.data);
	};

	formatDelay = (min) => {
		return min / 60;
	};

	render() {
		let analyse = this.props.analyses.focus.data;
		let { focus, list } = this.props.analyses;
		let newAnalysisLibrary = analyse !== null && analyse.id === undefined;
		let loading = this.props.catalog.loading;

		return (
			<>
				{loading && (
					<Dimmer active>
						<Loader />
					</Dimmer>
				)}
				{this.state.logs && <ImportModalLogs logs={this.state.logs} open={this.state.logsOpen} close={() => this.setState({ logsOpen: false })} />}
				<div style={styles.adminContainer}>
					<SidebarList
						list={this.props.analyses.list}
						categories={[]}
						onElementClick={this.focusOnElement}
						entity="ANALYSES"
						defaultLabel={(e) => e.code + " (" + e.label + ")"}
						focusedEltId={analyse}
					/>

					<ElementFocus
						element={focus}
						list={list}
						entity="Analyses"
						icon="lab"
						actionsFunction={[
							async () => {
								await this.props.getAnalysisImport().then(async () => {
									this.props.adminGetAllAnalysisLibrary();
									await this.props.getCatalogLogs().then((res) => {
										this.setState({ logs: res.payload.data });
										this.setState({ logsOpen: true });
									});
								});
							},
							async () => {
								await this.props.getCatalogLogs().then((res) => {
									this.setState({ logs: res.payload.data });
									this.setState({ logsOpen: true });
								});
							},
						]}
						actionsButton={[
							<>
								<Icon name="download" />
								Importer le catalogue d'analyses
							</>,
							<>
								<Icon name="file text" />
								Voir les logs d'import
							</>,
						]}
					>
						{analyse !== null && (
							<Formik
								enableReinitialize
								initialValues={{
									id: analyse.id,
									code: analyse.code || "",
									version: analyse.version || 0,
									code_comment: analyse.code_comment || "",
									color: analyse.color || "#00a793",
									color_priority: analyse.color_priority || 0,
									display_order: analyse.display_order || 0,
									label: analyse.label || "",
									synonyms: analyse.description ? analyse.description.split(";").join("\n") : "",
									multiple_take: Boolean(analyse.multiple_take),
									isAvailableWithoutCatalog: analyse.isAvailableWithoutCatalog || false,
									sil_code: analyse.sil_code || "",
									catalog_code: analyse.catalog_code || "",
									catalog_id: analyse.catalog_id || 0,
									sil_import: Boolean(analyse.sil_import),
									source: analyse.source || "",
									systematic: Boolean(analyse.systematic),
									group: analyse.group || "",
									taking_note: analyse.taking_note || "",
									subcontracting: Boolean(analyse.subcontracting),
									subcontracter: analyse.subcontracter || "",
									urgent: Boolean(analyse.urgent),
									special_diet: Boolean(analyse.special_diet),
									diet: analyse.diet || "",
									home_prohibited: Boolean(analyse.home_prohibited),
									home_not_recommended: Boolean(analyse.home_not_recommended),
									fasting: Boolean(analyse.fasting),
									light_protected: Boolean(analyse.light_protected),
									required_consent: Boolean(analyse.required_consent),
									pretreatment_stability: this.formatDelay(analyse.pretreatment_stability) || 0,
									pretreatment_note: analyse.pretreatment_note || "",
									pretreatment_urgent: Boolean(analyse.pretreatment_urgent),
									pretreatment_type: analyse.pretreatment_type || "",
									pretreatment_delay: this.formatDelay(analyse.pretreatment_delay) || 0,
									pt_transport: analyse.pt_transport || "",
									analysis_addition_time_limit: this.formatDelay(analyse.analysis_addition_time_limit) || 0,
									analysis_completion_delay: this.formatDelay(analyse.analysis_completion_delay) || "",
									pretreatment_centrifuge_prog: analyse.pretreatment_centrifuge_prog || "",
									analyzer: analyse.analyzer || "",
									pipette_volume: analyse.pipette_volume || 0,
									dead_space: analyse.dead_space || 0,
									treatment_day_monday: Boolean(analyse.treatment_day_monday),
									treatment_day_tuesday: Boolean(analyse.treatment_day_tuesday),
									treatment_day_wednesday: Boolean(analyse.treatment_day_wednesday),
									treatment_day_thursday: Boolean(analyse.treatment_day_thursday),
									treatment_day_friday: Boolean(analyse.treatment_day_friday),
									treatment_day_saturday: Boolean(analyse.treatment_day_saturday),
									treatment_day_sunday: Boolean(analyse.treatment_day_sunday),
									time_to_results: this.formatDelay(analyse.time_to_results) || 0,
									clinical_interest: analyse.clinical_interest || "",
									note_for_patient: analyse.note_for_patient || "",
									results_prescriber_only: Boolean(analyse.results_prescriber_only),
									start_date: analyse.start_date ? moment(analyse.start_date).format("DD/MM/YYYY") : "",
									end_date: analyse.end_date ? moment(analyse.end_date).format("DD/MM/YYYY") : "",
									status: analyse.status === "ACTIVE",
									loinc_demand:
										analyse.codes && analyse.codes.length > 0 && analyse.codes.filter((c) => c.type === "loinc_demand").length === 1
											? analyse.codes.filter((c) => c.type === "loinc_demand")[0].code
											: "",
									sil_envoi:
										analyse.codes && analyse.codes.length > 0 && analyse.codes.filter((c) => c.type === "sil_send").length === 1
											? analyse.codes.filter((c) => c.type === "sil_send")[0].code
											: "",
									code_aes:
										analyse.codes && analyse.codes.length > 0 && analyse.codes.filter((c) => c.type === "code_aes").length === 1
											? analyse.codes.filter((c) => c.type === "code_aes")[0].code
											: "",
									is_covid: analyse.is_covid || false,
									waiting_time_before_sampling: analyse.waiting_time_before_sampling || 0,
									identity_check: analyse.identity_check || false,
									bionext_price: analyse.bionext_price || false,
									weight_for_motivation: analyse.weight_for_motivation || 1,
									calculating_cost: analyse.calculating_cost,
									motives:
										analyse?.questions
											.filter((q) => q.question && q.question.motivation && q.question.answer_options)
											.flatMap((q) => q.question.answer_options.map((ao) => ao.answer_option)) || [],
								}}
								onSubmit={(values, { setSubmitting }) => {
									this.saveFocus(values, setSubmitting);
								}}
							>
								{({ isSubmitting, setFieldValue, values, errors }) => (
									<Form>
										<Grid style={{ margin: 0 }}>
											<Grid.Row columns={1}>
												<Grid.Column>
													<SecondaryButton type="button" style={{ float: "left" }} onClick={this.props.resetFocusAnalysisLibrary}>
														Fermer
													</SecondaryButton>
													<MainButton
														text={<Icon name="save" />}
														type="submit"
														style={{ float: "left" }}
														isSubmitting={isSubmitting}
														disabled={Object.entries(errors).length > 0 && errors.constructor === Object}
													>
														Enregistrer
													</MainButton>

													{!newAnalysisLibrary && (
														<RedButton
															text={<Icon name="trash" />}
															type="button"
															onClick={(e) => {
																if (e !== undefined) e.preventDefault();
																this.deleteFocus();
															}}
															style={{ float: "right" }}
														>
															Supprimer
														</RedButton>
													)}
												</Grid.Column>
											</Grid.Row>

											<Grid.Row columns={3}>
												<Grid.Column>
													<AdminDataContainer ribbonColor="red" ribbonLabel="Général">
														<GeneralForm values={values} />
													</AdminDataContainer>
													<div style={{ height: 20 }}>&nbsp;</div>
													<AdminDataContainer ribbonColor="green" ribbonLabel="Codes">
														<CodesForm values={values} />
													</AdminDataContainer>
													<div style={{ height: 20 }}>&nbsp;</div>
													<AdminDataContainer ribbonColor="pink" ribbonLabel="Questions">
														{this.state.questionsFactory.value ? (
															<QuestionsFormOrder
																updateQuestions={(value) => this.updateFactoryValue(value, "questionsFactory")}
																questionsFactory={this.state.questionsFactory}
															/>
														) : null}
													</AdminDataContainer>
													<div style={{ height: 20 }}>&nbsp;</div>
													<AdminDataContainer ribbonColor="olive" ribbonLabel="Motivations">
														<MotivationsForm values={values} />
													</AdminDataContainer>
												</Grid.Column>

												<Grid.Column>
													<AdminDataContainer ribbonColor="teal" ribbonLabel="Patient">
														<PatientForm values={values} />
													</AdminDataContainer>
													<div style={{ height: 20 }}>&nbsp;</div>
													<AdminDataContainer ribbonColor="orange" ribbonLabel="Prélèvement">
														<TakingForm values={values} />
													</AdminDataContainer>

													<div style={{ height: 20 }}>&nbsp;</div>

													<AdminDataContainer ribbonColor="purple" ribbonLabel="Tubes">
														<TubesForm tubesSelected={this.state.tubesSelected} />
													</AdminDataContainer>
													<div style={{ height: 20 }}>&nbsp;</div>
												</Grid.Column>

												<Grid.Column>
													<AdminDataContainer ribbonColor="yellow" ribbonLabel="Pré-traitement">
														<PretreatmentForm values={values} />
													</AdminDataContainer>

													<div style={{ height: 20 }}>&nbsp;</div>

													<AdminDataContainer ribbonColor="olive" ribbonLabel="Analytics">
														<AnalyticsForm values={values} />
													</AdminDataContainer>
													<div style={{ height: 20 }}>&nbsp;</div>
													<AdminDataContainer ribbonColor="blue" ribbonLabel="Autres">
														<OthersForm values={values} />
													</AdminDataContainer>
												</Grid.Column>
											</Grid.Row>
										</Grid>
									</Form>
								)}
							</Formik>
						)}
					</ElementFocus>
				</div>
			</>
		);
	}
}

const styles = {
	adminContainer: {
		height: "100%",
		width: "100%",
		paddingTop: 43,
		fontSize: 0,
		display: "flex",
	},
	blocWhiteAnalysesAdmin: {
		boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
		backgroundColor: "#fff",
		padding: 20,
		borderRadius: "0 0 4px 4px",
	},
	blocHeader: {
		backgroundColor: "rgb(0, 147, 128)",
		padding: 10,
		width: "100%",
		borderRadius: "4px 4px 0 0",
	},
};

const mapStateToProps = (state) => {
	return {
		analyses: state.admin.analyses,
		tubes: state.admin.tubes,
		questions: state.admin.questions,
		catalog: state.admin.catalog,
	};
};

const mapDispatchToProps = {
	adminGetAllAnalysisLibrary,
	adminGetAnalysisLibrary,
	adminPatchAnalysisLibrary,
	adminDeleteAnalysisLibrary,
	resetFocusAnalysisLibrary,
	adminPostAnalysisLibrary,
	initNewAnalysisLibrary,
	adminGetAllTubeLibrary,
	adminGetAllQuestionLibrary,
	getAnalysisImport,
	getAnalysisImportFile,
	getCatalogLogs,
};

export default connect(mapStateToProps, mapDispatchToProps)(AnalysesAdmin);
